import { useWidgetTitleHeight } from "arkh";
import { useMemo } from "react";
import { useWidgetLayout } from "./WidgetLayoutContext";

export const useWidgetLayoutContentSize = () => {
  const titleHeight = useWidgetTitleHeight();

  const { width, height, h } = useWidgetLayout();

  return useMemo(
    () => ({
      width,
      height: height - titleHeight,
      unit: (height - titleHeight) / h,
    }),
    [h, height, titleHeight, width]
  );
};
